import DateTimePickerController from './date-time-picker.controller';
import { DateTimePickerProps } from './date-time-picker.model';

const DateTimePicker = (props: DateTimePickerProps) => {
  return <DateTimePickerController {...props} />;
};

export default DateTimePicker;
